function init_mini_carousel() {
    var $mini_carousels = $('.js-mini-carousel');

    if(!$mini_carousels.length) {
        return;
    }

    $mini_carousels.each(function() {
        $this = $(this);
        $wrapper = $this.find('.mini-carousel__wrapper');
        $slides = $wrapper.children();

        // Check if more than one slide
        if($slides.length > 1) {
            $wrapper.slick({
                autoplay: true,
                arrows: false,
                speed: 500,
                slidesToShow: 1,
                infinite: true,
                waitForAnimate: false,
                dots: true,
                pauseOnFocus: false,
                pauseOnHover: false,
                lazyLoad: 'ondemand',
                centerMode: false,

                swipeToSlide: true,
                touchThreshold: 10,
            });
        }
    });
}

$(document).ready(function() {
    init_mini_carousel();
});